/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { I18nProvider, PerformanceMetricsProvider } from '@atlassian/embedded-confluence-common';
import fetchTranslations from '../i18n/fetchTranslations';
import { fg } from '@atlaskit/platform-feature-flags';
var styles = {
  fallback: "_1bsb1osq _4t3i1osq"
};
var LazyViewPage = lazyForPaint(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-view-page" */
  './ViewPage');
});
var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return fg('embedded-confluence-performance-markers') ? /*#__PURE__*/React.createElement(PerformanceMetricsProvider, {
    contentType: "viewPage"
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export var ViewPage = function ViewPage(props) {
  return /*#__PURE__*/React.createElement(I18nProvider, {
    locale: props.locale,
    fetchTranslations: fetchTranslations
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      xcss: styles.fallback
    })
  }, /*#__PURE__*/React.createElement(LazyViewPage, props))));
};